export default {
      id: "i-telegram-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-telegram-icon",
      toString: function () {
        return this.url;
      }
    }